




































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import FieldTitle from '../../../../../Pi/components/FieldTitle.vue'
import CustomEditor from '../../../logic/Editor/CustomEditor'
import FlowSettings from './FlowSettings.vue'
import FlowStatistics from './FlowStatisticsSettings.vue'
import HotKeys from './HotKeys.vue'
import { HotKey } from './type'

enum Page {
  settings,
  hot_keys,
  hint,
  statistics,
}

@Component({
  components: {
    FlowStatistics,
    FieldTitle,
    HotKeys,
    FlowSettings,
  },
  data() {
    return {
      Page,
    }
  }
})
export default class FlowHintComponent extends Vue {
  @Prop() editor!: CustomEditor

  newTitle = ''

  isOpen = false

  disabled = false

  hotKeys: Array<HotKey> = [
    {
      keys: [ { text: 'Ctrl' }, { icon: () => import('../navbarIcons/LMB.vue') } ],
      description: this.$t('ctrl_hot_key').toString(),
      inheritance: [
        {
          keys: [ { text: 'Delete' } ],
          description: this.$t('delete_hot_key').toString(),
        },
        {
          keys: [ { text: 'Ctrl' }, { text: 'C' } ],
          description: this.$t('ctrl_c_hot_key').toString(),
        },
        {
          keys: [ { text: 'Ctrl' }, { text: 'V' } ],
          description: this.$t('ctrl_v_hot_key').toString(),
        },
        {
          keys: [ { text: 'Ctrl' }, { icon: () => import('../navbarIcons/MouseMovement.vue') } ],
          description: this.$t('ctrl_mouse_move_hot_key').toString()
        },
      ]
    },
    {  keys: [ { text: 'Ctrl' }, { text: 'S' } ],
       description: this.$t('ctrl_s_hot_key').toString(),
    },
    {
      keys: [ { icon: () => import('../navbarIcons/RMB.vue') } ],
      description: this.$t('rmb_hot_key').toString()
    }
  ]

  renameFlow(): void {
    this.editor.flowSettingsController.renameFlow({ title: this.newTitle, key: this.editor.flowConfig.key })
  }

  mounted(): void {
    this.newTitle = this.editor.flowConfig.data.title
  }
}
